/* Smooth open/close for every info dropdown (product tabs, FAQ, any .accordion > details) */
(function () {
  if (window.tpAccordion) return;
  window.tpAccordion = true;
  const DURATION = 380;
  const EASING = 'cubic-bezier(.4,0,.2,1)';
  const reduced = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const supported = () => typeof Element.prototype.animate === 'function';

  function run(details, from, to, done) {
    if (details._tpAnim) details._tpAnim.cancel();
    details.style.overflow = 'hidden';
    const anim = details.animate({ height: [from + 'px', to + 'px'] }, { duration: DURATION, easing: EASING });
    details._tpAnim = anim;
    anim.onfinish = () => {
      details._tpAnim = null;
      details.style.overflow = '';
      if (done) done();
    };
    anim.oncancel = () => { details._tpAnim = null; details.style.overflow = ''; };
  }

  document.addEventListener('click', (e) => {
    const summary = e.target.closest('.accordion > details > summary');
    if (!summary || reduced() || !supported()) return;
    const details = summary.parentElement;
    e.preventDefault();
    const start = details.getBoundingClientRect().height;
    let expanded;
    if (!details.open || details.classList.contains('tp-closing')) {
      details.classList.remove('tp-closing');
      details.open = true;
      expanded = true;
      run(details, start, details.getBoundingClientRect().height);
    } else {
      details.classList.add('tp-closing');
      expanded = false;
      const end = summary.getBoundingClientRect().height + (details.offsetHeight - details.clientHeight);
      run(details, start, end, () => {
        details.open = false;
        details.classList.remove('tp-closing');
      });
    }
    /* the theme's own summary handler runs after this one; set the final state afterwards */
    setTimeout(() => summary.setAttribute('aria-expanded', String(expanded)), 0);
  }, true);
})();
